module.exports = __webpack_public_path__ + "img/option.a9da8e76.svg";